<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <div 
        class="payment-brand-avatar" 
        :style="avatarStyle"
        v-on="on"
      >
        <PaymentIcon 
          :name="normalizedBrand" 
          :size="size" 
          :color="iconColor"
        />
      </div>
    </template>
    <span>{{ friendlyBrandName }}</span>
  </v-tooltip>
</template>

<script>
import PaymentIcon from '@/components/PaymentIcon.vue';

export default {
  name: 'PaymentBrand',
  components: {
    PaymentIcon
  },
  props: {
    brand: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 36
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    normalizedBrand() {
      // Normalizar nomes das bandeiras para o PaymentIcon
      const brandMap = {
        'visa': 'visa',
        'visa electron': 'visa',
        'mastercard': 'mastercard',
        'maestro': 'maestro',
        'amex': 'amex',
        'american express': 'amex',
        'elo': 'elo',
        'elo debito': 'elo',
        'elo credito': 'elo',
        'dinersclub': 'dinersclub',
        'diners club': 'dinersclub',
        'discover': 'discover',
        'jcb': 'jcb',
        'hipercard': 'hipercard',
        'hiper': 'hipercard',
        'cabal': 'cabal'
      };

      const normalizedInput = (this.brand || '').toLowerCase().trim();
      return brandMap[normalizedInput] || normalizedInput || 'unknown';
    },
    iconColor() {
      // Usar cor personalizada se fornecida, senão deixar o ícone com suas cores originais
      return this.color || null;
    },
    avatarStyle() {
      return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderRadius: '50%',
        backgroundColor: this.color ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
        padding: '4px',
        cursor: 'pointer'
      };
    },
    friendlyBrandName() {
      // Mapeamento de nomes amigáveis das bandeiras
      const friendlyNames = {
        'visa': 'Visa',
        'mastercard': 'Mastercard',
        'maestro': 'Maestro',
        'amex': 'American Express',
        'elo': 'Elo',
        'dinersclub': 'Diners Club',
        'diners club': 'Diners Club',
        'discover': 'Discover',
        'jcb': 'JCB',
        'hipercard': 'Hipercard',
        'hiper': 'Hipercard',
        'cabal': 'Cabal',
        'cielo': 'Cielo',
        'rede': 'Rede',
        'pix': 'PIX',
        'googlepay': 'Google Pay',
        'applepay': 'Apple Pay',
        'paypal': 'PayPal',
        'samsung-pay': 'Samsung Pay'
      };

      const normalizedInput = (this.brand || '').toLowerCase().trim();
      
      // Tratamentos especiais
      if (normalizedInput.includes('elo')) {
        return 'Elo';
      }
      if (normalizedInput.includes('visa')) {
        return 'Visa';
      }
      if (normalizedInput.includes('master')) {
        return 'Mastercard';
      }
      if (normalizedInput.includes('amex') || normalizedInput.includes('american')) {
        return 'American Express';
      }

      return friendlyNames[normalizedInput] || 
             friendlyNames[this.normalizedBrand] || 
             (this.brand || 'Bandeira').replace(/^\w/, c => c.toUpperCase());
    }
  }
};
</script>

<style scoped>
.payment-brand-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  overflow: hidden;
}

/* Ajustar ícones dentro do avatar circular */
.payment-brand-avatar .payment-icon {
  max-width: 100%;
  max-height: 100%;
}
</style>